import { Card, Box, styled } from "@mui/material";

// STYLED COMPONENTS
const CardRoot = styled(Card)(() => ({
  height: "100%",
  padding: "8px 12px",
}));

const CardHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 8,
});

const CardTitle = styled("div")(({ subtitle, color }) => ({
  fontSize: "1rem",
  fontWeight: "500",
  textTransform: "capitalize",
  marginBottom: subtitle ? "4px" : 0, // Reduced because subtitle will have its own Box below
  color: color || "#333",
}));

// COMPONENT
export default function SimpleCard({
  children,
  title,
  subtitle,
  titleColor,
  actions, // new prop for buttons or actions JSX
}) {
  return (
    <CardRoot elevation={6}>
      <CardHeader>
        <Box>
          <CardTitle subtitle={subtitle} color={titleColor}>
            {title}
          </CardTitle>
          {subtitle && <Box>{subtitle}</Box>}
        </Box>

        {/* Render actions on the right side if provided */}
        {actions && <Box>{actions}</Box>}
      </CardHeader>

      {children}
    </CardRoot>
  );
}
